import {
  EMPTY_STRING,
  MAX_USERNAME_LENGTH,
} from "../../common/constants/common.constants";
import {
  checkEmailLink,
  validateAlphanumericString,
  validateSocialNetworks,
} from "../../utilities/helpers";

export const validateUserSettingsForm = (values, isAdmin: boolean) => {
  const errors: any = {};
  if (values.email === EMPTY_STRING || !checkEmailLink(values.email)) {
    errors.email = "Email address is not valid";
  }
  if (!values.discord || values.discord === EMPTY_STRING) {
    errors.discord = "Discord username can not be empty";
  }
  validateSocialNetworks(errors, values, true);

  if (values.username.length > MAX_USERNAME_LENGTH) {
    errors.username = "Username length can not exceed 18 characters";
  }

  if (
    values.username !== EMPTY_STRING &&
    !validateAlphanumericString(values.username)
  ) {
    errors.username = "Username can not contain special characters";
  }

  if (values.username === EMPTY_STRING) {
    errors.username = "Username can not be empty";
  }

  if (!values.country || values.country === EMPTY_STRING) {
    errors.country = "Country can not be empty";
  }

  if (values.editingWhitelistRequest && !isAdmin) {
    if (values.monkeInterests === EMPTY_STRING) {
      errors.monkeInterests = "Unique.vc Syndicate interests can not be empty";
    }
    if (
      values.areasOfInterest === EMPTY_STRING ||
      values.areasOfInterest.length === 0
    ) {
      errors.areasOfInterest = "Areas of interest can not be empty";
    }
    if (
      values.domainOfExpertise === EMPTY_STRING ||
      values.domainOfExpertise.length === 0
    ) {
      errors.domainOfExpertise = "Domain of expertise an not be empty";
    }
    if (values.personalBackground === EMPTY_STRING) {
      errors.personalBackground = "Personal background can not be empty";
    }
  }
  return errors;
};
